module.exports = __webpack_public_path__ + "img/weapon10.png";